module.exports = __webpack_public_path__ + "static/media/kg.0e8c2a1d.svg";